// src/components/sacred/MasteryChip.jsx
// Chip representing SRS card mastery state (new/learning/reviewing/mastered).
// Colours come from sacredCanvas.masteryColours.

import React from 'react';
import { Box } from '@mui/material';
import { masteryColours } from '../../theme/sacredCanvas';

const MasteryChip = ({ state = 'new', children, sx = {}, ...rest }) => {
  const c = masteryColours[state] || masteryColours.new;
  return (
    <Box
      component="span"
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.5,
        py: 0.5,
        borderRadius: 999,
        backgroundColor: c.bg,
        color: c.fg,
        border: state === 'mastered' ? `1px solid ${c.border}` : 'none',
        fontFamily: 'var(--sacred-font-body)',
        fontSize: '0.75rem',
        fontWeight: 600,
        letterSpacing: 0,
        // S8 — Sacred Canvas motion: state-change fade between
        // mastery levels. Honors prefers-reduced-motion via the
        // theme transitions config (durations collapse to 0).
        transition: theme.transitions.create(
          ['background-color', 'color', 'border-color'],
          { duration: theme.transitions.duration.short },
        ),
        ...(typeof sx === 'function' ? {} : sx),
      })}
      {...rest}
    >
      {children || c.label}
    </Box>
  );
};

export default MasteryChip;
